import { IFormInitialState } from '../errorLogic';

export function classes(...classNames: string[]): string {
  return classNames.filter(Boolean).join(' ');
}
export const isBillingFormInValid = (formState: IFormInitialState): boolean => {
  if (Object.keys(formState).length === 0) {
    return true;
  }
  return Object.values(formState).some(
    (field) =>
      field.error !== '' || (field.value === '' && field?.validation?.required),
  );
};
